document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('orderStatusForm');
  const submitBtn = document.getElementById('submitBtn');
  const errorMessage = document.getElementById('errorMessage');

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const orderNumber = document.getElementById('order_number').value.trim();
    const email = document.getElementById('email').value.trim();

    errorMessage.style.display = 'none';
    errorMessage.innerText = '';

    submitBtn.classList.add('loading');
    submitBtn.disabled = true;

    fetch('https://spapps.mymannerism.com/mannerism/fetch-order/get-order-status.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        order_number: orderNumber,
        email: email
      })
    })
    .then(res => res.json())
    .then(data => {
      console.log("data",data);
      if (data.success && data.confirmation_url) {
        // Allow browser to repaint before redirect
        setTimeout(() => {
          window.location.href = data.order_status_url;
        }, 100);

        // Safety reset if redirect fails
        setTimeout(() => {
          submitBtn.classList.remove('loading');
          submitBtn.disabled = false;
        }, 3000);

        return;
      }

      throw new Error('Invalid response');
    })
    .catch(() => {
      errorMessage.innerText = 'Order not found. Please check your order number and email.';
      errorMessage.style.display = 'block';

      submitBtn.classList.remove('loading');
      submitBtn.disabled = false;
      setTimeout(() => {
        errorMessage.style.display = 'none';
      }, 4000);
    });
  });
});
